<template>
  <div>
      <van-tabs v-model="activeName">
        <van-tab title="基本信息" name="a">
        <van-divider content-position="left">基本信息</van-divider>
          <van-field v-model="userName" label="登录账号" readonly />
          <van-form ref="formRef">
            <van-field v-model="form.agentName" label="用户名称" readonly/>
            <van-field clearable v-model="form.company" label="公司名称" placeholder="公司名称"/>
            <van-field clearable v-model="form.city" label="所属城市" required placeholder="所属城市" :rules="[{ required: true, message: '' }]" />
            <van-field clearable @input="buless" v-model="form.mobile" type="tel" required label="手机号码" placeholder="手机号码" :rules="[{ validator: PhoneMustBePostiveInt, message: '' }]" >
              <template #button>
                <van-button v-show="showxxx"  native-type="button" :disabled=formTime size="small" type="primary" @click="getVertify">
                  <span v-show="!formTime">发送验证码</span>
                  <van-count-down ref="countDown" v-show="formTime" time=60000 format="ss s后重新获取" @finish="changeDownCount" />
                </van-button>
              </template>
            </van-field>
            <van-field v-if="showxxx" name="userCode" colon v-model="form.userCode" type="digit" label="短信验证码" placeholder="请填写短信验证码" :rules="[{ required: true}]">
            </van-field>
                    <van-divider content-position="left">收件信息</van-divider>
            <van-field clearable v-model="form.deliveryName" required label="收件人姓名" placeholder="收件人姓名" :rules="[{ required: true, message: '' }]" />
            <van-field clearable v-model="form.deliveryMobile" required label="收件人电话" placeholder="收件人电话" :rules="[{ validator: PhoneMustBePostiveInt, message: '' }]" />
            <van-field clearable v-model="form.address" label="收件人地址" required placeholder="收件人地址" :rules="[{ required: true, message: '' }]" />
        <van-divider content-position="left">服务商资料</van-divider>
            <van-field clearable v-model="serviceForm.serviceName" label="服务商" required placeholder="服务商" :rules="[{ required: true, message: '' }]" />
            <van-field clearable v-model="serviceForm.mobile" type="tel" required label="联系方式" placeholder="联系方式" :rules="[{ required: true, message: '' }]" />
            <div style="margin: 16px;" class="btnssss">
              <van-button :disabled ="yzmFlag" block round size="small" type="info" native-type="button" @click="onSubmit">修改</van-button>
            </div>
          </van-form>
        </van-tab>
      </van-tabs>
  </div>
</template>

<script>
import { serviceInfo, myInfo, serviceEdit, myInfoEdit } from '@/api/user.js'
import { ForgetCode } from '@/api/login.js'
export default {
  name: 'AccountSetUPs',
  components: {},
  props: {},
  data () {
    return {
      activeName: 'a',
      // 登录账号
      userName: '',
      // 账户设置
      form: {
        agentName: '',
        company: '',
        city: '',
        mobile: '',
        deliveryName: '',
        deliveryMobile: '',
        address: ''
      },
      bfmyInfoForm: {},
      myInfoEditFlag: false,
      // 服务商资料
      serviceForm: {},
      // 联系方式
      mobile: '',
      // 服务商ID
      serviceId: '',
      // 服务商
      serviceName: '',
      // 发送验证码控制
      formTime: false,
      // 是否加载
      loadingShow: false,
      // 加载文字
      loadingValue: '',
      // 是否设置新密码
      passwordFlag: false,
      showxxx: false,
      yzmFlag: false
    }
  },
  watch: {},
  computed: {},
  methods: {
    buless (e) {
      this.showxxx = true
      this.yzmFlag = true
    },
    changeDownCount () {
      this.$refs.countDown.reset()
      this.formTime = false // 关闭倒计时状态
    },
    // 发送验证码 按钮
    async getVertify () {
      this.$refs.countDown.reset()
      const { data: res } = await ForgetCode({ account: this.userName })
      if (res.code === 0 && res.msg === '操作成功') {
        this.formTime = true // 关闭倒计时状态
        this.yzmFlag = false
        return this.$toast('验证码发送成功 请注意查收')
      }
      if (res.code === 1 && res.msg.indexOf('账号不存在, 请重新输入') !== -1) return this.$toast('账号不存在, 请重新输入')
      this.$toast.fail('验证码发送失败')
    },
    onSubmit () {
      this.$refs.formRef.validate().then(res => {
        this.serviceEdit()
      }).catch(res => {
        this.$toast.fail('请填写完整')
      })
    },
    PhoneMustBePostiveInt (phone) {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
      if (!myreg.test(phone)) {
        return false
      } else {
        return true
      }
    },
    // 服务商资料设置(显示)
    async serviceInfo () {
      const { data: res } = await serviceInfo({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0] })
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
      }
      this.serviceForm = res
    },
    // 个人资料设置(显示)
    async myInfo () {
      const { data: res } = await myInfo({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0] })
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
      }
      this.userName = res.userName
      this.form.agentName = res.agentName
      this.bfmyInfoForm = JSON.parse(JSON.stringify(res))
      this.form = res
    },
    // 服务商资料设置(修改)
    async serviceEdit () {
      const { data: res } = await serviceEdit({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0], serviceName: this.serviceForm.serviceName, mobile: this.serviceForm.mobile })
      if (res.code === 0) {
        this.myInfoEdit()
      }
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
      }
    },
    // 账户设置(修改)
    async myInfoEdit () {
      const { data: res } = await myInfoEdit({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0], company: this.form.company, city: this.form.city, mobile: this.form.mobile, deliveryName: this.form.deliveryName, deliveryMobile: this.form.deliveryMobile, address: this.form.address, code: this.form.userCode })
      if (res.code === 0) {
        this.$toast.success('修改成功')
        this.$router.push('/Home')
        // this.$router.go(-1)
      }
      if (res.code === 1 && res.msg.indexOf('验证码已过期, 请重新点击发送') !== -1) return this.$toast('验证码已过期, 请重新点击发送')
      if (res.code === 1 && res.msg.indexOf('验证码格式错误') !== -1) return this.$toast('验证码格式错误')
      if (res.code === 1 && res.msg.indexOf('账号不存在, 请重新输入') !== -1) return this.$toast('账号不存在, 请重新输入')
      if (res.code !== 0 && res.msg !== '操作成功') return this.$toast.fail('验证码错误')
      if (res.msg && res.msg.indexOf('请重新登录') !== -1) {
        this.$router.push('/login')
        this.$toast.fail('请重新登录')
      }
    }
  },
  beforeCreate () {},
  created () {
    this.serviceInfo()
    this.myInfo()
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .btnssss {
    .van-button {
      height: 75px;
    }
  }
  /deep/.van-divider {
    padding: 0 0 0 32px;
  }
  /deep/.van-divider--content-left::before {
    display: none;
  }
</style>
